var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',{staticClass:"app"},[_c('Navbar',{ref:"Navbar",attrs:{"name":_vm.$route.name}}),_c('div',{staticClass:"app__content"},[_c('router-view',{key:_vm.$route.fullPath,on:{"ProfilePictureChange":function($event){return _vm.changeNavProfilePic()}}})],1),_c('vue-confirm-dialog',{staticClass:"vue-confirm-dialog--test"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }